export default {
  name: "CountdownTimer",
  props: {
    // 接收时间参数，格式为"11:20"
    initialTime: {
      type: String,
      default: "00:00"
    },
    countdown: {
      type: Number,
      default: 1000
    },
    show: Boolean
  }
};